import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class AgentHierarchySearchHandler
  extends BaseSearchComponent<AgentService>
  implements OnInit, AfterViewInit
{
  public searchName: string;
  public isAdvanceSearchDisplayed: boolean;
  public item: any;
  public searchCriteriaData;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.searchName = 'SearchSupervisor';
    // this.service.responseIO.data.Entity.agentName = null;

    this.searchCriteriaData = {
      'AgentMasterDO.branchId': null,
      'AgentMasterDO.channelCd': null,
      'AgentMasterDO.parentAgencyId': null,
    };
    this.isAdvanceSearchDisplayed = true;
  }

  ngAfterViewInit() {
    // this.changeDetector.detectChanges();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Supervisor';
    return header;
  }
}
